import { toastError, toastSuccess } from "./redux/slices/other.slice";
import AdminLayout from "./components/admin/AdminLayout";
import { useDispatch, useSelector } from "react-redux";
import { Suspense, useEffect, useState } from "react";
import ProtectedRoute from './utils/ProtectedRoute';
import FrontendRoute from './router/FrontendRoute';
import Toaster from "./components/common/Toaster";
import Layout from './components/frontend/Layout';
import { Route, Routes } from "react-router-dom";
import NotFound from "./pages/frontend/NotFound";
import Loader from "./components/common/Loader";
import AdminRoute from './router/AdminRoute';
import { Cookies } from "react-cookie";
import io from 'socket.io-client'
import './i18n';

function App() {
  const cookies = new Cookies();
  const dispatch = useDispatch();
  const [socket, setSocket] = useState(null);
  // const SOCKET_SERVER_URL = "http://localhost:1000";
  const { data: user } = useSelector(state => state.AuthSlice);
  const SOCKET_SERVER_URL = "https://dashboard.motionride.co";//live code

  useEffect(() => {
    const newSocket = io(SOCKET_SERVER_URL, {
      secure: true,//live code
      transports: ['polling'],
      auth: { token: cookies.get('auth') }
    });
    setSocket(newSocket);

    return () => {
      newSocket.disconnect();
    };
  }, []);

  const updateCurrentLocationDriver = (data) => {
    if (socket) {
      socket.emit('updateCurrentLocationDriver', data, (response) => {
        dispatch(toastSuccess(`${response?.data?.type} ${response?.message} `));
      });
    }
  }

  useEffect(() => {
    if (socket && user) {
      socket.on('connect', () => {
        socket.emit('register', user?._id);
        console.log('Connected to WebSocket server', socket.id);
        updateCurrentLocationDriver({
          type: 'driver',
          lat: '30.71048293120724',
          lng: '76.72146080531934',
          user: '690d755055fc7ac5e481ae6c',
        });
      });
      // socket.emit('sendMessage', {
      //   senderId: user?._id,
      //   receiverId: '67d9032bfddda9cd7fdf3b0d',
      //   text: 'Hor v kidda men!',
      // });
      // socket.emit('driverArrived', {
      //   //   senderId: user?._id,
      //   rideId: '6825c298bfb02e57c9c8b0d8',
      //   type: 'book_ride',
      //   text: 'Hor v kidda Helo!',
      // }, (response) => {
      //   console.log(response)
      // });
      socket.on('receiveMessage', (data) => {
        console.log('Received:', data);
      });
      socket.on('driverArrivedMechanic', (data) => {
        console.log('driverArrivedMechanic:', data);
      });
      socket.on(`rideNotificationToUser-${user?._id}`, (data) => {
        console.log('Received:', data);
      });
      socket.on('connect_error', (err) => {
        console.error('Connection error:', err);
        dispatch(toastError(`Socket ${err?.message}`));
      });

      socket.on('newRideRequest-6866355ee3829ab0fb978a80', (response) => {
        console.log('newrequest', response);
        // dispatch(toastSuccess(`Ride request has been received from ${response} `));
      });
      socket.on('rideCanceledRequesttoDriver', (response) => {
        console.log('rideCanceledRequesttoDriver', response);
      });

      socket.on('newDeliveryRequest', (message) => {
        dispatch(toastSuccess(`Delivery request has been received from ${message?.passenger?.fullname} `));
      });

      socket.on('rideCanceledRequest', (message) => {
        dispatch(toastSuccess(`Delivery request has been cancelled from ${message?.passenger?.fullname} `));
      });

      socket.on('newErrandRequest', (message) => {
        dispatch(toastSuccess(`Errand request has been received from ${message?.passenger?.fullname} `));
      });

      socket.on(`currentDriverLocation-67ac37b8f15a6f82567c8f04`, (message) => {
        console.log('currentDriverLocation', message)
      });

      socket.on(`acceptRideNotificationToUser-68665364e3829ab0fb978d30`, (res) => {
        console.log(`acceptRideNotificationToUser:- ${JSON.stringify(res)} `);
      });
      socket.on(`booking_status_to_driver`, (response) => {
        console.log('booking_status_to_driver', response);
        // dispatch(toastSuccess(`Ride accepted by ${message?.driver?.fullname} `));
      });
      socket.on(`new_book_mech_request-${'67d2656b24bf2fcda7e6a8d3'}`, (response) => {
        console.log('new_book_mech_request', response);
        // dispatch(toastSuccess(`Ride accepted by ${message?.driver?.fullname} `));
      });
      socket.on(`driverNotificationToMechainc-67ac37b8f15a6f82567c8f04`, (response) => {
        console.log('driverNotificationToMechainc', response);
        // dispatch(toastSuccess(`Ride accepted by ${message?.driver?.fullname} `));
      });
      return () => {
        socket.off('connect');
        socket.off('connect_error');
      };
    }
  }, [socket, user]);

  return (
    <div className="App">
      <Toaster />
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/" element={<Layout />}>
            {FrontendRoute &&
              FrontendRoute.map((item, index) => (
                <Route key={index} path={item.path} element={item.component} />
              ))
            }
          </Route>
          <Route path="/admin" element={<AdminLayout />}>
            {AdminRoute &&
              AdminRoute.map((item, index) => (
                <Route key={index} path={item.path} element={<ProtectedRoute>{item.component}</ProtectedRoute>} />
              ))
            }
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
